import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const SettingsContext = createContext(null);

// Default fallback while loading
const FALLBACK = {
  logoUrl: '',
  siteName: "ANN'S Beauty Parlour",
  tagline: 'Where Elegance Meets Perfection',
  phone: '+91 98765 43210',
  email: 'hello@annsbeauty.in',
  address: 'Tirunelveli, Tamil Nadu',
  instagram: 'https://instagram.com/annsbeautyparlour',
  whatsapp: '919876543210',
  mapsUrl: 'https://maps.google.com/?q=ANN+Beauty+Parlour+Tirunelveli',
  workingHours: 'Mon–Sat: 9 AM – 8 PM | Sun: 10 AM – 6 PM'
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/settings')
      .then(res => {
        if (res.data.success) setSettings({ ...FALLBACK, ...res.data.data });
      })
      .catch(() => {}) // use fallback silently
      .finally(() => setLoading(false));
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
